import Rollbar from 'rollbar';
import config from '../services/rollbar.config';

export default {
  install(app) {
    if (!import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN) {
      Console.log('Local env, Rollbar disabled.');
      return;
    }

    const rollbar = new Rollbar(config);

    app.config.globalProperties.$rollbar = rollbar;
    app.provide('rollbar', rollbar);

    app.config.errorHandler = (err, vm, info) => {
      // Pass the real Error object (not a string) so Rollbar captures the stack
      // trace. The previous code reported `vm.$options.__file ?? err.message`,
      // which produced message-only items with no stack (and `__file` is stripped
      // in production, so every item was just the raw message). Custom context is
      // attached per-occurrence via the second arg instead of a global configure().
      rollbar.error(err, {
        service: 'Crafter V3 Frontend',
        component: vm?.$options?.name || vm?.$options?.__file || null,
        lifecycleHook: info || null,
      });
      // Keep it in the console too, but do NOT re-throw: re-throwing from Vue's
      // errorHandler turns it into an uncaught error (double-reported via
      // captureUncaught) and defeats Vue's error boundary.
      Console.error(err);
    };

    Console.log('Rollbar running.');
  },
};